import React from 'react';
import clsx from 'clsx';
import FormLabel from '@mui/material/FormLabel';
import SearchOutlined from '@mui/icons-material/SearchOutlined';

const SearchLabel = (props) => (
  <FormLabel
    className={clsx(props.className, 'search-label')}
    sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, mb: 0 }}
  >
    <SearchOutlined fontSize='small' /> Search
  </FormLabel>
);

export default SearchLabel;
